module.exports = __webpack_public_path__ + "static/media/gameCoverPlaceholder.85e4a181.png";